import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import PhoneNumber from '../PhoneNumber';
import FieldLabel from '../FieldLabel';

const PhoneNumberField = ({ name, label, isDisabled }) => {
    const { control } = useFormContext();

    return (
        <>
            {label && <FieldLabel label={label} name={name} />}

            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, value, ref }, formState: { errors } }) => (
                    <PhoneNumber
                        inputRef={ref}
                        value={value}
                        setValue={(phone) => onChange(phone)}
                        disabled={isDisabled}
                        inputClass={`${errors[name] ? 'error' : ''}`}
                    />
                )}
            />
        </>
    );
};

PhoneNumberField.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    control: PropTypes.object,
    isDisabled: PropTypes.bool,
};

PhoneNumberField.defaultProps = {
    isDisabled: false,
    label: '',
};

export default PhoneNumberField;
